// eslint-disable max-len
import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const BatteryLowNotificationIcon = createIcon({
  displayName: 'BatteryLowNotificationIcon',
  path: (
    <svg width="18" height="32" viewBox="0 0 18 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10587_54349)">
        {/* eslint-disable max-len */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.90944 26.1172H14.071C14.3688 26.1172 14.6089 26.3567 14.6089 26.6537V28.589C14.6089 28.886 14.3688 29.1256 14.071 29.1256H3.90944C3.61169 29.1256 3.37158 28.886 3.37158 28.589V26.6537C3.37158 26.3567 3.61169 26.1172 3.90944 26.1172Z"
          fill="currentColor"
        />
        <path
          d="M15.8865 3.00862C16.4147 3.00862 16.8373 3.43976 16.8373 3.95713V30.3811C16.8373 30.908 16.4051 31.3296 15.8865 31.3296H2.12321C1.59496 31.3296 1.17236 30.8984 1.17236 30.3811V3.96671C1.17236 3.43976 1.60457 3.0182 2.12321 3.0182H6.10909V1.50443C6.10909 1.04455 6.48366 0.670898 6.94468 0.670898H11.065C11.526 0.670898 11.9006 1.04455 11.9006 1.50443V3.0182H15.8865V3.00862Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10587_54349">
          <rect width="17" height="32" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 18 32',
});

export const TestNotificationIcon = createIcon({
  displayName: 'TestNotificationIcon',
  path: (
    <svg width="25" height="32" viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10584_52396)">
        <path
          d="M0.670898 29.2026C0.670898 30.3523 1.60024 31.3008 2.7691 31.3008L21.5763 31.3296C22.7356 31.3296 23.6745 30.4002 23.6745 29.2314V2.79784C23.6745 1.64814 22.7452 0.699641 21.5763 0.699641L2.7691 0.670898C1.60024 0.670898 0.670898 1.60024 0.670898 2.7691V29.2026Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1962 17.4561C11.4873 17.4561 10.9028 18.0309 10.9028 18.7495C10.9028 19.468 11.4777 20.0429 12.1962 20.0429C12.9148 20.0429 13.4897 19.468 13.4897 18.7495C13.4897 18.0309 12.9148 17.4561 12.1962 17.4561Z"
          fill="currentColor"
        />
        <path
          d="M12.1962 26.1558C11.4873 26.1558 10.9028 26.7306 10.9028 27.4492C10.9028 28.1677 11.4777 28.7426 12.1962 28.7426C12.9148 28.7426 13.4897 28.1677 13.4897 27.4492C13.4897 26.7306 12.9148 26.1558 12.1962 26.1558Z"
          fill="currentColor"
        />
        <path
          d="M8.65147 16.3642C8.35446 16.6612 8.35446 17.1498 8.65147 17.4468C8.79518 17.5905 8.9868 17.6672 9.18799 17.6672C9.38919 17.6672 9.58081 17.5905 9.72452 17.4468L10.2131 16.9582C11.3628 15.8085 13.2407 15.8085 14.3904 16.9582L14.7449 17.2935C14.8886 17.4372 15.0802 17.5139 15.2814 17.5139C15.4826 17.5139 15.6742 17.4372 15.8179 17.2935C15.9616 17.1498 16.0383 16.9582 16.0383 16.757C16.0383 16.5558 15.9616 16.3642 15.8179 16.2205L15.473 15.866C15.473 15.866 15.4443 15.8372 15.4347 15.8277L15.3293 15.7319C14.467 14.9462 13.3844 14.563 12.3018 14.563C11.1521 14.563 10.0119 15.0037 9.14009 15.8756L8.65147 16.3642Z"
          fill="currentColor"
        />
        <path
          d="M6.45754 14.5149C6.33299 14.6395 6.25635 14.8119 6.25635 14.994C6.25635 15.176 6.32341 15.3484 6.45754 15.4826C6.59168 15.6167 6.76413 15.6838 6.94617 15.6838C7.1282 15.6838 7.30066 15.6167 7.42521 15.4826L7.95216 14.9556C10.3378 12.6467 14.0839 12.6275 16.4887 14.8982L16.9102 15.3197C17.0348 15.4443 17.2072 15.5209 17.3893 15.5209C17.5713 15.5209 17.7438 15.4443 17.8779 15.3197C18.1462 15.0514 18.1462 14.6203 17.8779 14.352L17.351 13.8251C17.351 13.8251 17.2743 13.758 17.236 13.7389C15.818 12.4934 14.036 11.8706 12.254 11.8706C10.3569 11.8706 8.46952 12.57 7.02281 13.9592L6.44796 14.5245L6.45754 14.5149Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10584_52396">
          <rect width="24.3449" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 25 32',
});

export const GridRestoredIcon = createIcon({
  displayName: 'GridRestoredIcon',
  path: (
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10566_52251)">
        <path
          d="M27.0404 19.1626L23.9469 22.2561L22.5776 20.8868"
          stroke="currentColor"
          strokeWidth="1.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.2697 31.2525C31.1987 31.1815 31.1176 31.1307 31.0263 31.1003C30.935 31.0597 30.8336 31.0496 30.7423 31.0496H27.1721L26.0868 27.4185C25.6913 27.4895 25.2957 27.5301 24.8799 27.5301C24.7886 27.5301 24.6973 27.52 24.606 27.52L25.3363 29.9643L16.9889 24.0005L18.277 23.0775C18.0843 22.6109 17.9525 22.1139 17.8612 21.5967L15.7414 23.1079L10.2441 19.1827L15.7414 15.2474L18.5103 17.2252C18.7334 16.7891 18.987 16.3834 19.2913 15.9979L16.9889 14.3548L20.0216 12.1843L20.7518 14.6185C21.1575 14.3345 21.5835 14.081 22.0399 13.8781L20.549 8.87781H29.4136V11.0078C29.4136 11.1802 29.5049 11.3526 29.6368 11.4845C29.9106 11.7482 30.367 11.738 30.6409 11.4845C30.7727 11.3526 30.8539 11.1802 30.864 10.9976V8.14754C30.864 8.02583 30.8336 7.91426 30.7727 7.81284C30.7119 7.71141 30.6307 7.62013 30.5293 7.54913L19.9201 0.621712C19.7984 0.540571 19.6666 0.5 19.5246 0.5H11.948C11.806 0.5 11.6742 0.540571 11.5525 0.621712L0.96355 7.56941C0.862124 7.64041 0.77084 7.72155 0.720127 7.83312C0.659271 7.93455 0.628843 8.05626 0.628843 8.17797V11.0382C0.628843 11.2106 0.720127 11.383 0.851981 11.5149C1.12583 11.7786 1.58225 11.7685 1.84596 11.5149C1.97781 11.383 2.05895 11.2106 2.0691 11.0281V8.90824H10.9338L4.32076 31.0496H0.730269C0.638986 31.0496 0.557845 31.0597 0.476704 31.0902C0.38542 31.1206 0.304279 31.1713 0.233281 31.2423C0.162282 31.3133 0.101426 31.3945 0.0608558 31.4857C0.0202853 31.577 0 31.6683 0 31.7697C0 31.8712 0.0202853 31.9624 0.0608558 32.0537C0.101426 32.145 0.152139 32.2262 0.223138 32.2971C0.294136 32.3681 0.375277 32.4189 0.466561 32.4493C0.557845 32.4899 0.659271 32.5 0.760697 32.5H30.722C30.8336 32.5 30.9249 32.5 31.0162 32.4594C31.1075 32.429 31.1987 32.3681 31.2596 32.3073C31.3306 32.2363 31.3813 32.1552 31.432 32.0639C31.4726 31.9726 31.4929 31.8813 31.4929 31.7799C31.4929 31.6784 31.4726 31.5872 31.432 31.4959C31.3914 31.4046 31.3306 31.3235 31.2596 31.2525H31.2697ZM20.3055 2.58938L27.7198 7.4477H20.3055V2.58938ZM12.6479 1.9504H18.8552V7.4477H12.6479V1.9504ZM12.4552 8.8981H19.0276L19.5753 10.7339L15.7414 13.4724L11.9074 10.7238L12.4552 8.8981ZM3.77306 7.4477L11.1975 2.57924V7.4477H3.77306ZM11.4713 12.1843L14.504 14.3548L9.82821 17.7019L11.4713 12.1945V12.1843ZM9.10808 20.126L14.5141 23.9903L6.17686 29.9542L9.11823 20.126H9.10808ZM7.12013 31.0496L15.7515 24.8829L24.3829 31.0496H7.12013Z"
          fill="currentColor"
        />
        <path
          d="M24.8799 26.6884C21.4212 26.6884 18.6016 23.8789 18.6016 20.4101C18.6016 16.9413 21.4111 14.1318 24.8799 14.1318C28.3486 14.1318 31.1581 16.9413 31.1581 20.4101C31.1581 23.8789 28.3486 26.6884 24.8799 26.6884ZM24.8799 15.5619C22.2022 15.5619 20.0215 17.7426 20.0215 20.4203C20.0215 23.0979 22.2022 25.2786 24.8799 25.2786C27.5575 25.2786 29.7382 23.0979 29.7382 20.4203C29.7382 17.7426 27.5575 15.5619 24.8799 15.5619Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10566_52251">
          <rect width="31.4929" height="32" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 32 33',
});

export const GridOutageIcon = createIcon({
  displayName: 'GridOutageIcon',
  path: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10566_52255)">
        <path
          d="M30.83 30.32C30.76 30.25 30.68 30.2 30.59 30.17C30.5 30.13 30.4 30.12 30.31 30.12H26.79L25.72 26.54C25.33 26.61 24.94 26.65 24.53 26.65C24.44 26.65 24.35 26.64 24.26 26.64L24.98 29.05L16.75 23.17L18.02 22.26C17.83 21.8 17.7 21.31 17.61 20.8L15.52 22.29L10.1 18.42L15.52 14.54L18.25 16.49C18.47 16.06 18.72 15.66 19.02 15.28L16.75 13.66L19.74 11.52L20.46 13.92C20.86 13.64 21.28 13.39 21.73 13.19L20.26 8.26H29V10.36C29 10.53 29.09 10.7 29.22 10.83C29.49 11.09 29.94 11.08 30.21 10.83C30.34 10.7 30.42 10.53 30.43 10.35V7.54C30.43 7.42 30.4 7.31 30.34 7.21C30.28 7.11 30.2 7.02 30.1 6.95L19.64 0.12C19.52 0.04 19.39 0 19.25 0H11.78C11.64 0 11.51 0.04 11.39 0.12L0.95 6.97C0.85 7.04 0.76 7.12 0.71 7.23C0.65 7.33 0.62 7.45 0.62 7.57V10.39C0.62 10.56 0.71 10.73 0.84 10.86C1.11 11.12 1.56 11.11 1.82 10.86C1.95 10.73 2.03 10.56 2.04 10.38V8.29H10.78L4.26 30.12H0.72C0.63 30.12 0.55 30.13 0.47 30.16C0.38 30.19 0.3 30.24 0.23 30.31C0.16 30.38 0.1 30.46 0.06 30.55C0.02 30.64 0 30.73 0 30.83C0 30.93 0.02 31.02 0.06 31.11C0.1 31.2 0.15 31.28 0.22 31.35C0.29 31.42 0.37 31.47 0.46 31.5C0.55 31.54 0.65 31.55 0.75 31.55H30.29C30.4 31.55 30.49 31.55 30.58 31.51C30.67 31.48 30.76 31.42 30.82 31.36C30.89 31.29 30.94 31.21 30.99 31.12C31.03 31.03 31.05 30.94 31.05 30.84C31.05 30.74 31.03 30.65 30.99 30.56C30.95 30.47 30.89 30.39 30.82 30.32H30.83ZM20.02 2.06L27.33 6.85H20.02V2.06ZM12.47 1.43H18.59V6.85H12.47V1.43ZM12.28 8.28H18.76L19.3 10.09L15.52 12.79L11.74 10.08L12.28 8.28ZM3.72 6.85L11.04 2.05V6.85H3.72ZM11.31 11.52L14.3 13.66L9.69 16.96L11.31 11.53V11.52ZM8.98 19.35L14.31 23.16L6.09 29.04L8.99 19.35H8.98ZM7.02 30.12L15.53 24.04L24.04 30.12H7.02Z"
          fill="currentColor"
        />
        <path
          d="M23.0002 21.8298C22.8302 21.8298 22.6502 21.7598 22.5202 21.6298C22.2602 21.3698 22.2602 20.9398 22.5202 20.6698L25.5702 17.6198C25.8302 17.3598 26.2602 17.3598 26.5202 17.6198C26.7802 17.8798 26.7802 18.3098 26.5202 18.5798L23.4702 21.6298C23.3402 21.7598 23.1702 21.8298 22.9902 21.8298H23.0002Z"
          fill="currentColor"
        />
        <path
          d="M26.0502 21.8298C25.8802 21.8298 25.7002 21.7598 25.5702 21.6298L22.5202 18.5798C22.2602 18.3198 22.2602 17.8898 22.5202 17.6198C22.7802 17.3598 23.2102 17.3598 23.4702 17.6198L26.5202 20.6698C26.7802 20.9298 26.7802 21.3598 26.5202 21.6298C26.3902 21.7598 26.2202 21.8298 26.0402 21.8298H26.0502Z"
          fill="currentColor"
        />
        <path
          d="M24.5298 25.8199C21.1198 25.8199 18.3398 23.0499 18.3398 19.6299C18.3398 16.2099 21.1098 13.4399 24.5298 13.4399C27.9498 13.4399 30.7198 16.2099 30.7198 19.6299C30.7198 23.0499 27.9498 25.8199 24.5298 25.8199ZM24.5298 14.8499C21.8898 14.8499 19.7398 16.9999 19.7398 19.6399C19.7398 22.2799 21.8898 24.4299 24.5298 24.4299C27.1698 24.4299 29.3198 22.2799 29.3198 19.6399C29.3198 16.9999 27.1698 14.8499 24.5298 14.8499Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10566_52255">
          <rect width="31.05" height="31.55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 32 32',
});

export const NewDeviceDetectedIcon = TestNotificationIcon;

export const StormModeActiveIcon = createIcon({
  displayName: 'StormModeActiveIcon',
  path: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10575_52272)">
        <path
          d="M22.7985 16.7881H27.8914C29.726 16.7881 31.2357 15.3166 31.2452 13.4821V13.4438C31.2452 11.0933 29.6591 9.12494 27.5379 8.64719C27.7576 7.20437 27.2225 5.68511 26.0282 4.75827C24.5758 3.63077 22.6074 3.71676 21.2602 4.85382C19.76 2.35038 17.1037 0.678242 14.0652 0.678242C9.69851 0.668687 6.09624 4.11807 5.63759 8.54208C5.5516 8.54208 5.45605 8.54208 5.37005 8.54208C2.77107 8.54208 0.668945 10.7398 0.668945 13.4438V13.4821C0.6785 15.3166 2.1882 16.7881 4.02278 16.7881H7.79704"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3618 19.2537C20.3045 19.1486 20.1994 19.0817 20.0847 19.0817H15.0969L18.9572 10.0617C18.9763 9.87061 18.8521 9.69862 18.6705 9.67951C18.5463 9.6604 18.4317 9.72728 18.3648 9.84195L8.77146 22.0438C8.67591 22.2062 8.72369 22.426 8.87657 22.5216C8.92434 22.5502 8.98167 22.5789 9.04856 22.5789H13.8643L9.99451 31.6276C9.98496 31.8282 10.1092 31.9906 10.2907 32.0098C10.4054 32.0098 10.52 31.9524 10.5869 31.8473L20.3522 19.6264C20.4096 19.5213 20.4096 19.3875 20.3522 19.2824H20.3713L20.3618 19.2537Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10575_52272">
          <rect width="31.914" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 32 32',
});

export const OffGridModeActiveIcon = createIcon({
  displayName: 'OffGridModeActiveIcon',
  path: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10575_52275)">
        <path
          d="M30.83 30.32C30.76 30.25 30.68 30.2 30.59 30.17C30.5 30.13 30.4 30.12 30.31 30.12H26.79L25.72 26.54C25.33 26.61 24.94 26.65 24.53 26.65C24.44 26.65 24.35 26.64 24.26 26.64L24.98 29.05L16.75 23.17L18.02 22.26C17.83 21.8 17.7 21.31 17.61 20.8L15.52 22.29L10.1 18.42L15.52 14.54L18.25 16.49C18.47 16.06 18.72 15.66 19.02 15.28L16.75 13.66L19.74 11.52L20.46 13.92C20.86 13.64 21.28 13.39 21.73 13.19L20.26 8.26H29V10.36C29 10.53 29.09 10.7 29.22 10.83C29.49 11.09 29.94 11.08 30.21 10.83C30.34 10.7 30.42 10.53 30.43 10.35V7.54C30.43 7.42 30.4 7.31 30.34 7.21C30.28 7.11 30.2 7.02 30.1 6.95L19.64 0.12C19.52 0.04 19.39 0 19.25 0H11.78C11.64 0 11.51 0.04 11.39 0.12L0.95 6.97C0.85 7.04 0.76 7.12 0.71 7.23C0.65 7.33 0.62 7.45 0.62 7.57V10.39C0.62 10.56 0.71 10.73 0.84 10.86C1.11 11.12 1.56 11.11 1.82 10.86C1.95 10.73 2.03 10.56 2.04 10.38V8.29H10.78L4.26 30.12H0.72C0.63 30.12 0.55 30.13 0.47 30.16C0.38 30.19 0.3 30.24 0.23 30.31C0.16 30.38 0.1 30.46 0.06 30.55C0.02 30.64 0 30.73 0 30.83C0 30.93 0.02 31.02 0.06 31.11C0.1 31.2 0.15 31.28 0.22 31.35C0.29 31.42 0.37 31.47 0.46 31.5C0.55 31.54 0.65 31.55 0.75 31.55H30.29C30.4 31.55 30.49 31.55 30.58 31.51C30.67 31.48 30.76 31.42 30.82 31.36C30.89 31.29 30.94 31.21 30.99 31.12C31.03 31.03 31.05 30.94 31.05 30.84C31.05 30.74 31.03 30.65 30.99 30.56C30.95 30.47 30.89 30.39 30.82 30.32H30.83ZM20.02 2.06L27.33 6.85H20.02V2.06ZM12.47 1.43H18.59V6.85H12.47V1.43ZM12.28 8.28H18.76L19.3 10.09L15.52 12.79L11.74 10.08L12.28 8.28ZM3.72 6.85L11.04 2.05V6.85H3.72ZM11.31 11.52L14.3 13.66L9.69 16.96L11.31 11.53V11.52ZM8.98 19.35L14.31 23.16L6.09 29.04L8.99 19.35H8.98ZM7.02 30.12L15.53 24.04L24.04 30.12H7.02Z"
          fill="currentColor"
        />
        <path
          d="M21.0002 23.8398C20.8302 23.8398 20.6502 23.7698 20.5202 23.6398C20.2602 23.3798 20.2602 22.9498 20.5202 22.6798L27.6002 15.5998C27.8602 15.3398 28.2902 15.3398 28.5502 15.5998C28.8102 15.8598 28.8102 16.2898 28.5502 16.5598L21.4702 23.6398C21.3402 23.7698 21.1702 23.8398 20.9902 23.8398H21.0002Z"
          fill="currentColor"
        />
        <path
          d="M24.5298 25.8199C21.1198 25.8199 18.3398 23.0499 18.3398 19.6299C18.3398 16.2099 21.1098 13.4399 24.5298 13.4399C27.9498 13.4399 30.7198 16.2099 30.7198 19.6299C30.7198 23.0499 27.9498 25.8199 24.5298 25.8199ZM24.5298 14.8499C21.8898 14.8499 19.7398 16.9999 19.7398 19.6399C19.7398 22.2799 21.8898 24.4299 24.5298 24.4299C27.1698 24.4299 29.3198 22.2799 29.3198 19.6399C29.3198 16.9999 27.1698 14.8499 24.5298 14.8499Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10575_52275">
          <rect width="31.05" height="31.55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 32 32',
});

export const LowPowerModeActiveIcon = createIcon({
  displayName: 'LowPowerModeActiveIcon',
  path: (
    <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9998 13.3298L17.2898 4.92983C17.3498 4.82983 17.4698 4.77983 17.5798 4.78983C17.7598 4.79983 17.8898 4.94983 17.8698 5.12983L17.3098 10.7598H20.7198C20.7798 10.7598 20.8398 10.7798 20.8898 10.8098C21.0398 10.8998 21.0898 11.0898 20.9898 11.2398L16.6098 19.6398C16.5398 19.7398 16.4298 19.7998 16.2998 19.7798C16.1198 19.7598 15.9898 19.5998 16.0098 19.4298L16.7098 13.8098H13.2298C13.1098 13.8098 12.9998 13.7498 12.9498 13.6498H12.9698C12.9098 13.5498 12.9098 13.4198 12.9698 13.3298H12.9998Z"
        fill="currentColor"
      />
      <path
        d="M28.92 1V14.78H33L17.1 29.01L1 14.73H5.31V1H28.92Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 34 30',
});

export const DeviceOfflineIcon = createIcon({
  displayName: 'DeviceOfflineIcon',
  path: (
    <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10577_52296)">
        <path
          d="M23.7703 16.8335H27.9667C29.8062 16.8335 31.32 15.358 31.3296 13.5185V13.4802C31.3296 11.1233 29.7392 9.14966 27.6122 8.67062C27.8326 7.22391 27.296 5.70056 26.0984 4.77121C24.6422 3.64068 22.6685 3.7269 21.3176 4.86702C19.8134 2.35684 17.1499 0.680196 14.1032 0.680196C9.72479 0.670615 6.11281 4.1293 5.65293 8.56523C5.56671 8.56523 5.4709 8.56523 5.38467 8.56523C2.77868 8.56523 0.670898 10.7688 0.670898 13.4802V13.5185C0.680479 15.358 2.19425 16.8335 4.03377 16.8335H7.8182"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.4241 14.4097L13.5762 19.248"
          stroke="currentColor"
          strokeWidth="1.51"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.4241 19.248L13.5762 14.4097"
          stroke="currentColor"
          strokeWidth="1.51"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0002 24.3163C20.1328 24.3163 23.4828 20.9663 23.4828 16.8337C23.4828 12.7012 20.1328 9.35107 16.0002 9.35107C11.8677 9.35107 8.51758 12.7012 8.51758 16.8337C8.51758 20.9663 11.8677 24.3163 16.0002 24.3163Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10577_52296">
          <rect width="32" height="24.9868" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 32 25',
});

export const InverterIcon = createIcon({
  displayName: 'InverterIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
      <path
        d="M23.3799 25.75H7.0499C6.5499 25.75 6.1499 26.15 6.1499 26.65C6.1499 27.15 6.5499 27.55 7.0499 27.55H23.3799C23.8699 27.55 24.2799 27.15 24.2799 26.65C24.2799 26.15 23.8799 25.75 23.3799 25.75Z"
        fill="currentColor"
      />
      <path
        d="M31.61 20.28C31.22 20.28 30.9 20.6 30.9 20.99V25.77H29.54V25.33C29.54 25.33 29.54 25.26 29.54 25.22C29.48 24.76 29.1 24.4 28.63 24.39H28.57V22.84V4.12C28.57 2.95 27.62 2 26.45 2H4.06C2.89 2 1.94 2.95 1.94 4.12V24.39H1.91C1.41 24.39 1 24.8 1 25.3V27.65C1 27.65 1 27.72 1 27.76C1.06 28.22 1.44 28.58 1.91 28.59H1.94V29.31C1.94 30.48 2.89 31.43 4.06 31.43H26.45C27.62 31.43 28.57 30.48 28.57 29.31V28.59H28.63C29.13 28.59 29.54 28.18 29.54 27.68V27.2H31.61C32 27.2 32.32 26.88 32.32 26.49V21C32.32 20.61 32 20.29 31.61 20.29V20.28ZM4.06 3.42H26.45C26.84 3.42 27.15 3.74 27.15 4.12V22.13H3.36V4.12C3.36 3.73 3.68 3.42 4.06 3.42ZM26.45 30.02H4.06C3.67 30.02 3.36 29.7 3.36 29.32V23.56H27.15V29.32C27.15 29.71 26.83 30.02 26.45 30.02Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 34 34',
});

export const InverterErrorIcon = createIcon({
  displayName: 'InverterErrorIcon',
  path: (
    <svg width="33" height="28" viewBox="0 0 33 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.6602 19.6841H1.99512"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.201 17.9331V23.1197H27.0479"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.421 22.4209C21.8899 22.4209 22.2631 22.8037 22.2631 23.263C22.2631 23.7223 21.8803 24.1051 21.421 24.1051H6.0047C5.5358 24.1051 5.1626 23.7223 5.1626 23.263C5.1626 22.8037 5.54537 22.4209 6.0047 22.4209H21.421Z"
        fill="currentColor"
      />
      <path
        d="M26.541 22.0285V24.2486C26.541 24.3347 26.474 24.4017 26.3879 24.4017H25.9668V21.8467H26.3591C26.4548 21.8562 26.5314 21.9424 26.5314 22.0381L26.541 22.0285Z"
        stroke="currentColor"
        strokeWidth="1.48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 24.2199V21.9998C1 21.9137 1.06699 21.8467 1.15311 21.8467H1.57416V24.4017H1.18182C1.08612 24.3921 1.00957 24.306 1.00957 24.2103L1 24.2199Z"
        stroke="currentColor"
        strokeWidth="1.48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.584 8.46875L23.7275 12.3252"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.584 12.3252L23.7275 8.46875"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6605 16.3541C28.953 16.3541 31.6222 13.685 31.6222 10.3924C31.6222 7.09982 28.953 4.43066 25.6605 4.43066C22.3679 4.43066 19.6987 7.09982 19.6987 10.3924C19.6987 13.685 22.3679 16.3541 25.6605 16.3541Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.6606 17.9809C25.4309 17.9809 25.2108 17.9713 24.9907 17.9426V25.7799C24.9907 26.1435 24.6941 26.4402 24.3305 26.4402H3.18213C2.81849 26.4402 2.52184 26.1435 2.52184 25.7799V2C2.52184 1.63636 2.81849 1.33971 3.18213 1.33971H24.3209C24.6845 1.33971 24.9812 1.63636 24.9812 2V2.92823C25.2013 2.90909 25.4214 2.88995 25.651 2.88995C25.8807 2.88995 26.1008 2.89952 26.3209 2.92823V2C26.3209 0.889952 25.4214 0 24.3209 0H3.18213C2.08165 0 1.18213 0.899522 1.18213 2V25.7895C1.18213 26.8995 2.08165 27.7895 3.18213 27.7895H24.3209C25.4214 27.7895 26.3209 26.89 26.3209 25.7895V17.9522C26.1008 17.9713 25.8807 17.9904 25.651 17.9904L25.6606 17.9809Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 33 28',
});

export const BatteryErrorIcon = createIcon({
  displayName: 'BatteryErrorIcon',
  path: (
    <svg width="24" height="33" viewBox="0 0 24 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10577_52335)">
        <path
          d="M18.5798 16.1357L15.5044 19.2016"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5798 19.2016L15.5044 16.1357"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.0374 24.8257C16.8075 24.8257 16.5871 24.8162 16.3668 24.7874V30.8808C16.3668 31.0341 16.2422 31.1587 16.0889 31.1587H2.36916C2.21587 31.1587 2.09132 31.0341 2.09132 30.8808V4.46647C2.09132 4.31317 2.21587 4.18862 2.36916 4.18862H6.34521C6.71886 4.18862 7.01587 3.89162 7.01587 3.51796V2.00419C7.01587 1.91796 7.08293 1.84132 7.17874 1.84132H11.2889C11.3751 1.84132 11.4518 1.91796 11.4518 2.00419V3.51796C11.4518 3.7 11.5189 3.86287 11.653 3.99701C11.7775 4.12156 11.9308 4.17904 12.132 4.18862H16.1081C16.2614 4.18862 16.3859 4.30359 16.3859 4.45689V10.5216C16.6063 10.5024 16.8266 10.4832 17.0566 10.4832C17.2865 10.4832 17.5069 10.4928 17.7272 10.5216V4.45689C17.7272 3.56587 16.9991 2.83772 16.1081 2.83772H12.8027V2.00419C12.8027 1.17066 12.132 0.5 11.2985 0.5H7.17874C6.35479 0.5 5.67455 1.17066 5.67455 2.00419V2.84731H2.36916C1.47814 2.84731 0.75 3.57545 0.75 4.46647V30.8808C0.75 31.7719 1.47814 32.5 2.36916 32.5H16.0985C16.9895 32.5 17.7177 31.7719 17.7177 30.8808V24.7874C17.4973 24.8066 17.2769 24.8257 17.047 24.8257H17.0374Z"
          fill="currentColor"
        />
        <path
          d="M17.0374 23.1969C20.0905 23.1969 22.5656 20.7219 22.5656 17.6688C22.5656 14.6157 20.0905 12.1406 17.0374 12.1406C13.9843 12.1406 11.5093 14.6157 11.5093 17.6688C11.5093 20.7219 13.9843 23.1969 17.0374 23.1969Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10577_52335">
          <rect width="22.4958" height="32" fill="white" transform="translate(0.75 0.5)" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 24 33',
});

export const MeterErrorIcon = createIcon({
  displayName: 'MeterErrorIcon',
  path: (
    <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10577_52341)">
        <path
          d="M2.79784 9.4082C1.64814 9.4082 0.699641 10.3375 0.699641 11.5064L0.670898 24.5651C0.670898 25.7244 1.60024 26.6633 2.7691 26.6633H29.2026C30.3523 26.6633 31.3008 25.7339 31.3008 24.5651L31.3296 11.5064C31.3296 10.3471 30.4002 9.4082 29.2314 9.4082H2.79784Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.4287 12.5603V9.4082"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.4287 26.6633V23.5112"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.11989 8.03809H6.97498C7.08037 8.03809 7.1666 8.12431 7.1666 8.2297V8.76623H3.88037V8.25844C3.89953 8.13389 3.99534 8.03809 4.11989 8.03809Z"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6.32314 6.2085H4.72314V7.8085H6.32314V6.2085Z" fill="currentColor" />
        <path
          d="M21.6717 0.0383539C22.122 -0.0957779 22.5915 0.162905 22.716 0.613204C22.8406 1.0635 22.5915 1.53296 22.1412 1.65752L5.48011 6.50542C5.02981 6.63955 4.56035 6.38087 4.43579 5.93057C4.31124 5.48027 4.56035 5.01081 5.01064 4.88626L21.6717 0.0383539Z"
          fill="currentColor"
        />
        <path
          d="M24.1822 16.23L20.666 19.7461"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.1822 19.7461L20.666 16.23"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.4289 23.4252C25.4291 23.4252 27.8613 20.9931 27.8613 17.9929C27.8613 14.9927 25.4291 12.5605 22.4289 12.5605C19.4287 12.5605 16.9966 14.9927 16.9966 17.9929C16.9966 20.9931 19.4287 23.4252 22.4289 23.4252Z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10577_52341">
          <rect width="32" height="27.3341" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  viewBox: '0 0 32 28',
});

export const BCSErrorIcon = createIcon({
  displayName: 'BCSErrorIcon',
  path: (
    <svg width="30" height="34" viewBox="0 0 30 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.47 15.2798L21.27 18.4798"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.47 18.4798L21.27 15.2798"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8696 22.6499C26.0563 22.6499 28.6396 20.0665 28.6396 16.8799C28.6396 13.6932 26.0563 11.1099 22.8696 11.1099C19.6829 11.1099 17.0996 13.6932 17.0996 16.8799C17.0996 20.0665 19.6829 22.6499 22.8696 22.6499Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.91 8.22V3.22C22.91 2.02 21.94 1.03 20.72 1.03L3.19 1C1.97 1 1 1.97 1 3.19V30.78C1 31.98 1.97 32.97 3.19 32.97L20.72 33C21.93 33 22.91 32.03 22.91 30.81V25.56"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7899 4.83008C17.0499 4.83008 16.4399 5.43008 16.4399 6.18008C16.4399 6.93008 17.0399 7.53008 17.7899 7.53008C18.5399 7.53008 19.1399 6.93008 19.1399 6.18008C19.1399 5.43008 18.5399 4.83008 17.7899 4.83008Z"
        fill="currentColor"
      />
      <path
        d="M16.21 6.18018H19.36"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7899 26.6099C17.0499 26.6099 16.4399 27.2099 16.4399 27.9599C16.4399 28.7099 17.0399 29.3099 17.7899 29.3099C18.5399 29.3099 19.1399 28.7099 19.1399 27.9599C19.1399 27.2099 18.5399 26.6099 17.7899 26.6099Z"
        fill="currentColor"
      />
      <path
        d="M16.21 27.96H19.36"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 30 34',
});
